import {
  ActivatedRouteSnapshot, CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from "@angular/router";
import {Injectable} from "@angular/core";
import {SessionManagerService} from "./session-manager.service";

@Injectable({ providedIn: "root" })
export class CheckAuthGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router, private auth: SessionManagerService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    console.log("canActivate called for:", state.url);
    return this.check(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    console.log("canActivateChild called for:", state.url);
    return this.check(route, state);
  }


  check(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    let session = localStorage.getItem("session");
    let token = localStorage.getItem("token");
    if (session && this.auth.isLoggedIn) {
      return true;
    } else {
      this.auth.logout()
      return this.router.parseUrl("/signin");
    }
  }
}
